var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.getStatus)?_c(_setup.BaseStatus,{staticClass:"status-cell",attrs:{"status":_setup.getStatus,"is-outline":"","disable-hover":_setup.props.data.disableHover}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }